import React, { useState } from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Row, Col } from "react-bootstrap";
import LeftHealth from "./LeftHealth";
import Overview from "./Overview";
import Doctors from "./Doctors";
import VisitingDoctors from "./VisitingDoctors";
import StaffNurse from "./StaffNurse";
import Facilities from "./Facilities";
import ReferralHospitals from "./ReferralHospitals";
import EmergencyContacts from "./EmergencyContacts";
import HealthCenterGallery from "./HealthCenterGallery";

function Main() {
    const [activeIndex, setActiveIndex] = useState(0);
    const getHeading = () => {
        switch (activeIndex) {
            case 0:
                return "Overview";
            case 1:
                return "Doctors";
            case 2:
                return "Visiting Doctors";
            case 3:
                return "Staff Nurse";
            case 4:
                return "Facilities";
            case 5:
                return "Referral Hospitals";
            case 6:
                return "Emergency Contacts";
            case 7:
                return "Gallery";
            default:
                return "Null";
        }
    };

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Health Center" />
            <section className="project-detail">
                <div className="container">
                    <div
                        className="section-title center-align mb-50 wow fadeInDown animated"
                        data-animation="fadeInDown"
                        data-delay=".4s"
                    >
                        <h5>
                            <i className="fal fa-graduation-cap" />{" "}
                            Health Center
                        </h5>
                        <h2>{getHeading()}</h2>
                    </div>
                    <Row>
                        <Col md={4} className="c-left mb-25">
                            <LeftHealth
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                        </Col>
                        <Col md={8} className="c-left">
                            <Row>
                                {activeIndex === 0 && <Overview />}
                                {activeIndex === 1 && <Doctors />}
                                {activeIndex === 2 && <VisitingDoctors />}
                                {activeIndex === 3 && <StaffNurse />}
                                {activeIndex === 4 && <Facilities />}
                                {activeIndex === 5 && <ReferralHospitals />}
                                {activeIndex === 6 && <EmergencyContacts />}
                                {activeIndex === 7 && <HealthCenterGallery />}
                            </Row>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;
